import { atom, useAtom } from 'jotai';
import type { useGetRecentlyViewedGoods } from '../hooks/useGetRecentlyViewedGoods';
import { useAppLifeCycle } from 'shared/src/hooks';
import { memo } from 'react';
import { bridge, useAsyncEffect } from 'shared/src/utils';

export type InfiniteRecentlyViewedGoods = ReturnType<
  typeof useGetRecentlyViewedGoods
>['recentlyViewedGoods'];

export const infiniteRecentlyViewedGoodsAtom = atom<
  InfiniteRecentlyViewedGoods | undefined
>(undefined);

export const SyncZZimData = memo(
  ({
    children,
  }: {
    children: ({
      syncedInfiniteRecentlyViewedGoods,
    }: {
      syncedInfiniteRecentlyViewedGoods: InfiniteRecentlyViewedGoods;
    }) => React.ReactNode;
  }) => {
    const { lifeCycle } = useAppLifeCycle();
    const [infiniteRecentlyViewedGoods, setInfiniteRecentlyViewedGoods] =
      useAtom(infiniteRecentlyViewedGoodsAtom);

    useAsyncEffect(async () => {
      if (!infiniteRecentlyViewedGoods) {
        return;
      }

      if (lifeCycle === 'viewWillAppear') {
        const localGoodsLike = await bridge.getLocalGoodsLike();

        const syncedGoods = infiniteRecentlyViewedGoods.goods.map(goods => {
          const syncedGoodsLike = localGoodsLike?.[goods.sno];
          if (syncedGoodsLike === undefined) {
            return goods;
          }
          return { ...goods, like: syncedGoodsLike };
        });
        setInfiniteRecentlyViewedGoods({
          ...infiniteRecentlyViewedGoods,
          // ...syncedGoods,
          goods: syncedGoods,
        });
      }
    }, [lifeCycle]);

    return (
      <>
        {children({
          syncedInfiniteRecentlyViewedGoods: infiniteRecentlyViewedGoods ?? {
            per_page: 0,
            goods: [],
            last_sno: null,
            list_id: '',
            list_params: '',
          },
        })}
      </>
    );
  },
);
